import { createFileRoute } from '@tanstack/react-router'

import { BatchesPage } from '@/pages/batches/Batches.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/',
)({
  component: BatchesPage,
  loader: () => ({ breadcrumbTitle: 'Batches' }),
})
